module.exports = __webpack_public_path__ + "static/media/cse_6.a2e18fa1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/cse_6.jpg
// module id = 98
// module chunks = 0